import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import LocationTable from './locationmasters-table';
import LocationTile from './locationmasters-tile';
import LocationSearch from './locationmasters-search';
import { selectLocationFilterVisible, selectTileView } from './store/selectors'; // Import the selector

const LocationContent = props => {
  const isFilterVisible = useSelector(selectLocationFilterVisible); // Use the selector
  const showTileView = useSelector(selectTileView); // Use the selector

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top">
          <LocationSearch />
        </div>
        {/* {isFilterVisible && <LocationFilter />} */}

        {!showTileView ? <LocationTable /> : <LocationTile />}
      </div>
    </div>
  );
};

export default LocationContent;
